import React from 'react';

const Safety = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['verified_user', 'health_and_safety', 'shield', 'security', 'medical_services', 'emergency', 'warning', 'check_circle'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Safety First
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Safety at Bel-Aire Mechanical
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              SAFETY + QUALITY + PRODUCTION = Healthy Work Force and Healthy Company
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Safety Philosophy */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Our Safety Philosophy</h2>
            <p>Protecting our most valuable resources – our employees</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Bel-Aire Mechanical values finding the proper balance between creating an inclusive company culture, 
                running a profitable business, meeting customer requirements and building high quality projects all 
                while maintaining the <strong style={{color: 'var(--accent-blue)'}}>highest level of safety achievable</strong>.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                We go-all-out to reduce the number of hazards that each of our employees encounters on a daily basis 
                by ensuring they are equipped with the knowledge it takes to be safe. As a company dedicated to 
                operational excellence, we are very proud of the safety record that we've worked hard to achieve 
                and invest daily in executing the responsible actions it takes to protect our most valuable resources – 
                our employees.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Safety Culture Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto', marginBottom: '3rem'}}>
            <div style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: 0, textAlign: 'center'}}>
                <strong style={{color: 'var(--accent-blue)'}}>Zero injuries, each and every day, that's our goal!</strong> Our roadmap to successfully 
                accomplishing this starts with daily pre-planning activities and ends with takeaway meetings.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Safety Practices */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(0, 104, 166, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Our Safety Practices</h2>
            <p>Best-in-class safety systems led by our Safety Director</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Employees, we believe, are our greatest asset and the number one path to growth and success for our team. 
                Compromising their safety and health is unconscionable. That's why, within the framework of a high quality 
                and productive work site, we do everything in our power to protect them from harm and possible exposure to 
                unwanted events.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                Our Safety Director, <strong style={{color: 'var(--accent-blue)'}}>Scott Kienast</strong>, heads the corporate safety team. Under his direction, 
                Bel-Aire has instituted a company-wide system of policies, procedures and practices that are best in class. 
                The system has a proven track record for protecting our employees from industry recognized occupational safety 
                and health hazards, and our current EMR of <strong style={{color: 'var(--accent2-red)'}}>0.58</strong> is proof positive that it works.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Safety Director Scott Kienast Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div style={{background: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'}}>
              <h3 style={{fontSize: '1.5rem', color: 'var(--accent-blue)', marginBottom: '1rem', textAlign: 'center'}}>Proactive Safety Culture</h3>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: 0, textAlign: 'center'}}>
                By valuing safety and investing in a pro-active safety culture, we've been able to create work practices that 
                allow us to continually improve our safety and health performance and confidently aspire to meet our Zero injury goal.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Field Safety */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Our Field Safety</h2>
            <p>Comprehensive safety measures for dynamic construction environments</p>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '0 auto'}}>
            <div className="safety-cards-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(2, 1fr)', 
              gap: '2rem'
            }}>
              <div className="safety-card safety-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2.5rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 6px 20px rgba(0, 104, 166, 0.2)'
              }}>
                <div className="safety-card-icon" style={{fontSize: '4rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>security</span></div>
                <h3 className="safety-card-title" style={{fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--white)'}}>Safety Professionals</h3>
                <p className="safety-card-text" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>Dedicated safety professionals ensuring comprehensive protection on every jobsite.</p>
                <ul className="safety-card-list" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Pre-employment drug screening</li>
                  <li>Safety orientation training</li>
                  <li>Pre-task planning and hazard analysis</li>
                  <li>Daily and weekly safety meetings</li>
                  <li>STOP &gt; CORRECT &gt; REPORT protocol</li>
                </ul>
              </div>
              
              <div className="safety-card safety-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2.5rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 6px 20px rgba(171, 22, 54, 0.2)'
              }}>
                <div className="safety-card-icon" style={{fontSize: '4rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>construction</span></div>
                <h3 className="safety-card-title" style={{fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--white)'}}>Jobsite Safety</h3>
                <p className="safety-card-text" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>Dynamic construction environments require proactive safety planning and execution.</p>
                <ul className="safety-card-list" style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Safety, quality and productivity design</li>
                  <li>Hazard exposure minimization</li>
                  <li>Employee empowerment programs</li>
                  <li>Effective communication channels</li>
                  <li>Continuous safety improvement</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Safety Highlights */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(0, 104, 166, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Safety Highlights</h2>
            <p>Proven track record of safety excellence</p>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '0 auto'}}>
            <div className="safety-highlights-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(4, 1fr)', 
              gap: '2rem'
            }}>
              <div className="safety-highlight-card safety-highlight-blue" style={{
                background: 'var(--white)', 
                padding: '2rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                border: '3px solid var(--accent-blue)'
              }}>
                <div className="safety-highlight-number" style={{fontSize: '3rem', marginBottom: '1rem', color: 'var(--accent-blue)'}}>5</div>
                <div className="safety-highlight-label" style={{fontSize: '1.1rem', fontWeight: 'bold', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Dedicated Full-time Safety Professionals</div>
              </div>
              
              <div className="safety-highlight-card safety-highlight-red" style={{
                background: 'var(--white)', 
                padding: '2rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                border: '3px solid var(--accent2-red)'
              }}>
                <div className="safety-highlight-number" style={{fontSize: '3rem', marginBottom: '1rem', color: 'var(--accent2-red)'}}>0.58</div>
                <div className="safety-highlight-label" style={{fontSize: '1.1rem', fontWeight: 'bold', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Current EMR</div>
              </div>
              
              <div className="safety-highlight-card safety-highlight-blue" style={{
                background: 'var(--white)', 
                padding: '2rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                border: '3px solid var(--accent-blue)'
              }}>
                <div className="safety-highlight-number" style={{fontSize: '3rem', marginBottom: '1rem', color: 'var(--accent-blue)'}}>0.60</div>
                <div className="safety-highlight-label" style={{fontSize: '1.1rem', fontWeight: 'bold', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Five Year Average EMR</div>
              </div>
              
              <div className="safety-highlight-card safety-highlight-red" style={{
                background: 'var(--white)', 
                padding: '2rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                border: '3px solid var(--accent2-red)'
              }}>
                <div className="safety-highlight-number" style={{fontSize: '2.5rem', marginBottom: '1rem', color: 'var(--accent2-red)'}}>2017-2019</div>
                <div className="safety-highlight-label" style={{fontSize: '1.1rem', fontWeight: 'bold', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>SMACNA Safety Excellence Award Winner</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Safety;
